// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__i51bq","container":"Footer_container__-G6ob","socialIcons":"Footer_socialIcons__CuhMU"};